export default function auth({ next, router }) {
  // const session = localStorage.getItem('session') || sessionStorage.getItem('session')
   const session = localStorage.getItem('user_lab_profile')
  if (!session) {
    return router.push({ name: 'auth-login' });
  } else {
    const parsedSession = JSON.parse(session)

    if (parsedSession.role.id !== 1 && parsedSession.role.id !== 5) {
      return router.push({ name: 'home' })
    }
  }
  return next();
}